const emailTemplateSkeleton = `
<meta charset="UTF-8">
<title>Notification Cooptaleo</title>


<table width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color:#f9f9f9; padding:20px 0;">
<tbody><tr>
<td align="center">
<table width="600" cellpadding="0" cellspacing="0" style="background-color:#ffffff; border-radius:6px; overflow:hidden;">
<!-- Header -->
<tbody><tr>
<td style="background-color:#18395C; padding:20px; text-align:center;">
<img src="https://cooptaleo.com/images/footer/logo.png" alt="Cooptaleo" width="140" style="display:block; margin:0 auto;">
</td>
</tr>
 
          <!-- Body -->
<tr>
<td style="padding:30px 40px;">
<h2 style="color:#18395C; font-size:22px; margin-bottom:20px;"><p class="MsoNormal" style="margin-bottom:12.0pt;line-height:normal;mso-pagination:
none;mso-layout-grid-align:none;text-autospace:none">ajouter votre message ici</p><p class="MsoNormal" style="margin-bottom:12.0pt;line-height:normal;mso-pagination:
none;mso-layout-grid-align:none;text-autospace:none"><br></p></h2><p style="text-align:center; margin-top:30px;"><br></p></td>
</tr> 
        </tbody></table>
</td>
</tr>
</tbody></table>


`;

export default emailTemplateSkeleton;